import React from 'react'
import Onboarding from '../../Components/Onboarding/Onboarding'

const OnboardingPage = ({ match, location }) => {
  return (
    <React.Fragment>
      <Onboarding />
    </React.Fragment>
  )
}

export default OnboardingPage
